<template>
  <div>
    <canvas ref="canvas" width="460" height="200" style="border:1px solid #ccc;"></canvas>
  </div>
</template>
<script>
import SignaturePad from 'signature_pad'

import ws from '@/services/employees'
 
export default {
    name: 'employees_sign_canvas',
    mixins: [],
    emits: ['firmaGenerada'],
    props: {

    },
    components: {
        
    },
    data(){
        return{
            showModal: true,
            employee: null,
            document: null,
            signaturePad: null
        }
    },
    mounted() {
        const canvas = this.$refs.canvas
        this.signaturePad = new SignaturePad(canvas)
    },
    methods: {
        async loadEmployee(employee, document) {
            this.employee = employee;
            this.document = document;
        },
        clearSignature() {
            this.signaturePad.clear()
        },
        saveSignature() {
            if (this.signaturePad.isEmpty()) {
                this.$toast.error("Por favor firma antes de guardar.");
                return
            }
            
            const dataUrl = this.signaturePad.toDataURL('image/png')
            this.$emit('signProcess', dataUrl) // Puedes guardar esto en el backend
        },
        async importDocument() {
            const form = document.getElementById("document_file_form");
            const formData = new FormData(form);

            let response = await ws.uploadEmployeesDocument(formData);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit("imported",response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeEmployeesImportModal.click();
        }
    }
}
</script>

<style scoped>
canvas {
  touch-action: none;
}
</style>